import axios from "axios";

// Same-origin API base: the platform ingress routes /api/* to the backend on
// whatever domain serves the app (preview AND production custom domain alike).
// Only fall back to the build-time backend URL for local development
// (localhost), where the backend genuinely lives on a different port.
// This keeps every request first-party: no CORS, no third-party cookies, and
// iOS Safari's cross-site tracking prevention never comes into play.
const envBase = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const isLocalDev = ["localhost", "127.0.0.1"].includes(window.location.hostname);
const sameOriginEnv = envBase && envBase === window.location.origin;
const API = `${isLocalDev || sameOriginEnv ? envBase : window.location.origin}/api`;

// Auth tokens live in httpOnly cookies set by the server — nothing sensitive
// is persisted to web storage (localStorage/sessionStorage are XSS-readable).
// In-memory tokens are kept only as a same-tab fallback for edge browsers.
const memoryTokens = { child: null, staff: null };
export const getToken = (kind) => memoryTokens[kind];
export const setToken = (kind, token) => { memoryTokens[kind] = token; };
export const clearToken = (kind) => { memoryTokens[kind] = null; };
export const clearAllTokens = () => { memoryTokens.child = null; memoryTokens.staff = null; };

const make = (kind) => {
  const inst = axios.create({ baseURL: API, withCredentials: true });
  inst.interceptors.request.use((cfg) => {
    const t = memoryTokens[kind];
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
  });
  return inst;
};

export const childApi = make("child");
export const staffApi = make("staff");

export const API_BASE = API;

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || String(x)).join(" ");
  return String(d);
}
